import React, { useEffect, useState } from 'react'

export const useMapLayout = (
  containerRef: React.RefObject<HTMLDivElement>,
  threshold = 450
): { useColumnLayout: boolean } => {
  const [useColumnLayout, setUseColumnLayout] = useState(false)

  useEffect(() => {
    if (!containerRef.current) return

    const containerObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width } = entry.contentRect
        setUseColumnLayout(width < threshold)
      }
    })

    containerObserver.observe(containerRef.current)

    const initialWidth = containerRef.current.getBoundingClientRect().width
    setUseColumnLayout(initialWidth < threshold)

    return () => {
      containerObserver.disconnect()
    }
  }, [containerRef, threshold])

  return { useColumnLayout }
}

export default useMapLayout
